import { useId } from 'react'
import { cn } from '@/lib/utils'

/** The Nebueye mark: an open eye whose iris carries a magenta glint. */
export function LogoMark({ className }: { className?: string }) {
  const id = useId()
  return (
    <svg viewBox="0 0 32 32" aria-hidden className={cn('size-7 shrink-0', className)}>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="var(--brand-from)" />
          <stop offset="1" stopColor="var(--brand-to)" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill={`url(#${id})`} />
      <path
        d="M5.5 16c2.9-4.6 6.4-6.9 10.5-6.9s7.6 2.3 10.5 6.9c-2.9 4.6-6.4 6.9-10.5 6.9S8.4 20.6 5.5 16Z"
        fill="none"
        stroke="oklch(0.985 0.01 286)"
        strokeWidth="2"
      />
      <circle cx="16" cy="16" r="3.6" fill="oklch(0.985 0.01 286)" />
      <circle cx="17.3" cy="14.7" r="1.1" fill="var(--brand-accent)" />
    </svg>
  )
}

export function Logo({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <LogoMark />
      <span className="text-[15px] font-semibold tracking-[-0.02em]">Nebueye</span>
    </span>
  )
}
